import GlobalDispatcher from 'Engine/events/GlobalDispatcher';

export default class ControllerBringToFrontSymbols extends PIXI.Container {
  constructor() {
    super();
    this.symbols = [];
    this.parents = [];
    this.addListeners()
  }
  addListeners() {
    GlobalDispatcher.add('specilalSymbol: hitTheBar', this.onHitSymbolTheBar, this);
    GlobalDispatcher.add('stateManager.stateChanged', this.onStateChanged, this);
  }

  onHitSymbolTheBar({params: symbol}) {
    this._bringSymbolToFront(symbol)
  }

  onStateChanged({params: stateName}) {
    if (stateName === 'requestRollingState') {
      this._bringSymbolsBack();
    }
  }

  _bringSymbolToFront(symbol) {
    this.parents.push(symbol.parent);
    const animationSymbolPosition = this.toLocal({ x: 0 , y: 0 }, symbol);
    symbol.x = animationSymbolPosition.x;
    symbol.y = animationSymbolPosition.y;
    this.addChild(symbol);
    this.symbols.push(symbol);
  }

  _bringSymbolsBack() {
    this.symbols.forEach((symbol, index) =>{
      const animationSymbolPosition = this.parents[index].toLocal({ x: 0 , y: 0 }, symbol);
      symbol.x = animationSymbolPosition.x;
      symbol.y = animationSymbolPosition.y;
      this.parents[index].addChild(symbol);
    })
    this.symbols = [];
    this.parents = [];
  }
}
